import { Inject, Injectable } from '@angular/core'

import { LOCATION } from '../../variables'
import { BackendService, RequestOptionsArgs } from '../backend/backend.service'

@Injectable()
export class ApiService {
  apiEndpoint: string
  token: string

  constructor(@Inject(LOCATION) private location: any, private backendService: BackendService) {
    const parts = location.hostname.split('.').slice(1)
    this.apiEndpoint = ['api', ...parts].join('.')
  }

  public load(path: string, options: RequestOptionsArgs = {}) {
    const url = `//${this.apiEndpoint}/v1${path}`
    options.withCredentials = true
    return this.backendService.load(url, options)
  }

  public create(path: string, body: any, options: RequestOptionsArgs = {}) {
    const url = `//${this.apiEndpoint}/v1${path}`
    options.withCredentials = true
    return this.backendService.create(url, body, options)
  }

  public update(path: string, object: any, options: RequestOptionsArgs = {}) {
    const url = `//${this.apiEndpoint}/v1${path}`
    options.withCredentials = true
    return this.backendService.update(url, object, options)
  }

  public delete(path: string, options: RequestOptionsArgs = {}) {
    const url = `//${this.apiEndpoint}/v1${path}`
    options.withCredentials = true
    return this.backendService.delete(url, options)
  }
}
